/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Action_SaveInputs */

const en_settings_action_save = /** @type {(inputs: Settings_Action_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Settings`)
};

const es_settings_action_save = /** @type {(inputs: Settings_Action_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar configuración`)
};

const fr_settings_action_save = /** @type {(inputs: Settings_Action_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les paramètres`)
};

const de_settings_action_save = /** @type {(inputs: Settings_Action_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen speichern`)
};

const ja_settings_action_save = /** @type {(inputs: Settings_Action_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を保存`)
};

const zh_settings_action_save = /** @type {(inputs: Settings_Action_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存设置`)
};

const ar_settings_action_save = /** @type {(inputs: Settings_Action_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حفظ الإعدادات`)
};

const id_settings_action_save = /** @type {(inputs: Settings_Action_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan Pengaturan`)
};

const it_settings_action_save = /** @type {(inputs: Settings_Action_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva Impostazioni`)
};

const ru_settings_action_save = /** @type {(inputs: Settings_Action_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить настройки`)
};

const pt_settings_action_save = /** @type {(inputs: Settings_Action_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar Configurações`)
};

const ko_settings_action_save = /** @type {(inputs: Settings_Action_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설정 저장`)
};

/**
* | output |
* | --- |
* | "Save Settings" |
*
* @param {Settings_Action_SaveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const settings_action_save = /** @type {((inputs?: Settings_Action_SaveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Action_SaveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_action_save(inputs)
	if (locale === "es") return es_settings_action_save(inputs)
	if (locale === "fr") return fr_settings_action_save(inputs)
	if (locale === "de") return de_settings_action_save(inputs)
	if (locale === "ja") return ja_settings_action_save(inputs)
	if (locale === "zh") return zh_settings_action_save(inputs)
	if (locale === "ar") return ar_settings_action_save(inputs)
	if (locale === "id") return id_settings_action_save(inputs)
	if (locale === "it") return it_settings_action_save(inputs)
	if (locale === "ru") return ru_settings_action_save(inputs)
	if (locale === "pt") return pt_settings_action_save(inputs)
	return ko_settings_action_save(inputs)
});